import LoginDialog from "./LoginDialog";
import { useAuthContext } from "../../context/AuthContext";
import Loader from "../basic/Loader";
import { Navigate, useLocation } from "react-router-dom";
import login_image from "../../assets/images/login-image.png";
import { useEffect, useState } from "react";
import CustomDialog from "../basic/Dialog";
import { Dialog } from "@headlessui/react";
import { getTrackBackground, Range } from "react-range";
import { Icon } from "@iconify/react";
import { postTrailFeedback } from "../../api/api";
import { toast } from "react-toastify";
import newLoginDialog_bg from "../../assets/images/newLoginDialog_bg.png";
import loginImg from "../../assets/images/new_login_Image.png";

export function FeedbackDialog({ showFeedBack, workout, close }) {
  const [feedback, setFeedback] = useState("");
  const [rating, setRating] = useState([1]);
  return (
    <CustomDialog show={showFeedBack} close={close}>
      <Dialog.Panel>
        <div className="relative w-full md:max-w-4xl flex flex-row flex-1 p-4 md:p-10 bg-gradient-to-r from-[#2A2A35] to-[#494959F2]  rounded-xl ">
          <div
            onClick={close}
            className="cursor-pointer bg-[#d9d9d9] rounded-full absolute -right-2 md:-right-5 -top-2 md:-top-5 w-10 h-10 justify-center items-center flex"
          >
            <Icon icon="carbon:close" className="h-6 w-6" />
          </div>
          <div className="w-full flex flex-col">
            <p className="font-poppins bottom-3 left-5  text-white  text-lg md:text-xl text-left  leading-snug ">
              <span className="text-primary-neonGreen font-bold text-2xl md:text-4xl">
                Congratulations{" "}
              </span>
              <br /> on completing your first workout!
            </p>
            <p className="text-white font-bold md:text-lg text-left mt-5">
              How was your overall experience?*
            </p>

            <div className="relative px-5">
              <Range
                aria-label="Workout Duration"
                step={1}
                min={1}
                max={10}
                values={rating}
                onChange={(values) => {
                  setRating(values);
                }}
                renderTrack={({ props, children }) => (
                  <div
                    {...props}
                    style={{
                      ...props.style,
                      background: getTrackBackground({
                        values: rating,
                        colors: ["#0B28AC", "#6376CD"],
                        min: 1,
                        max: 10,
                      }),
                      cursor: "pointer",
                    }}
                    className="w-full h-2 mt-12 rounded-full "
                  >
                    {children}
                  </div>
                )}
                renderThumb={({ props }) => (
                  <div
                    aria-label="meeting minutes thumb"
                    {...props}
                    style={{
                      ...props.style,
                      outline: "none",
                      cursor: "pointer",
                    }}
                    className={`flex justify-center`}
                  >
                    <p
                      className={` font-bold text-center bg-primary-midBlack  rounded-full px-4 py-2 -mt-2 text-white self-center absolute -top-8`}
                    >
                      {rating[0]}
                    </p>
                    <span
                      aria-hidden="true"
                      className={`
            pointer-events-none justify-center items-center  inline-flex h-[24px] w-[24px] transform rounded-full bg-primary-white drop-shadow-[0_4px_4px_rgb(0,0,0,0,25)] ring-0 transition duration-200 ease-in-out`}
                    >
                      <span
                        aria-hidden="true"
                        className={`
            pointer-events-none inline-block drop-shadow-[0_4px_4px_rgb(0,0,0,0,25)] h-[12px] w-[12px] transform rounded-full bg-white  ring-0 transition duration-200 ease-in-out`}
                      />
                    </span>
                  </div>
                )}
              />
            </div>

            <p className="text-white font-bold md:text-lg text-left mt-5">
              What did you like the most?
            </p>
            <textarea
              className="px-4 py-3 mt-5 rounded-lg border-[1px] bg-transparent text-white placeholder-primary-gray border-gray-300 w-full"
              rows={3}
              value={feedback}
              onChange={(e) => {
                setFeedback(e.target.value);
              }}
              placeholder="Enter your feedback here"
            />

            <div
              onClick={async () => {
                const response = await postTrailFeedback({
                  rating: rating[0],
                  feedback: feedback,
                  workout: workout,
                });
                toast("Thank you for your feedback");
                close();
              }}
              className="text-primary-black max-w-max mt-5 flex bg-primary-neonGreen p-3 rounded-xl font-open-sans cursor-pointer"
            >
              Submit
            </div>
          </div>
        </div>
      </Dialog.Panel>
    </CustomDialog>
  );
}

function NewLoginPage() {
  const auth = useAuthContext();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const workoutDone = queryParams.get("workout");
  const [showFeedBack, setShowFeedBack] = useState(
    Boolean(queryParams.get("feedback")) || false
  );

  // if (auth.state.isLoading) {
  //   return <Loader />;
  // }

  if (auth.state.user) {
    // Redirect them to the /login page, but save the current location they were
    // trying to go to when they were redirected. This allows us to send them
    // along to that page after they login, which is a nicer user experience
    // than dropping them off on the home page.
    return <Navigate to="/programpage" state={{ from: location }} replace />;
  }

  return (
    <div
      className="md:mx-40 mx-10 my-10 grid md:grid-cols-2 md:grid-rows-1 grid-cols-1 grid-rows-2"
      // style={{
      //   backgroundImage: `url(${newLoginDialog_bg})`,
      //   backgroundSize: "cover",
      // }}
    >
      <div className="md:w-[700px] h-full">
        <img
          src={"https://ik.imagekit.io/getactyv/login_img.webp"}
          alt="Login_image"
          className="md:rounded-l-md "
        />
      </div>
      <div
        className="flex flex-col justify-center items-center md:rounded-r-md md:pt-0 pt-10 mt-0 bg-[#0E0E11]"
        // style={{
        //   background:
        //     "linear-gradient(0deg, #222631, #222631),linear-gradient(0deg, #3E3E3E, #3E3E3E)",
        // }}
      >
        <LoginDialog closeDialog={() => {}} />
      </div>
    </div>
  );
}

export default NewLoginPage;
